import { render } from "./doubleSlider.vue?vue&type=template&id=3b29ab58&scoped=true"
import script from "./doubleSlider.vue?vue&type=script&lang=js"
export * from "./doubleSlider.vue?vue&type=script&lang=js"

import "./doubleSlider.vue?vue&type=style&index=0&id=3b29ab58&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b29ab58"]])

export default __exports__